export default __webpack_public_path__ + "static/media/ajibadeemmanuel.ba69b20b.pdf";